"use client";

import { useQuery, useMutation } from "convex/react";
import { api } from "@convex/_generated/api";
import { useCallback } from "react";

export function useSettings() {
  const settings = useQuery(api.settings.getSettings);
  const updateSettingsMutation = useMutation(api.settings.updateSettings);

  const updateSettings = useCallback(
    async (updates: Parameters<typeof updateSettingsMutation>[0]) => {
      await updateSettingsMutation(updates);
    },
    [updateSettingsMutation]
  );

  return {
    settings,
    isLoading: settings === undefined,
    updateSettings,
  };
}
